module.exports = __webpack_public_path__ + "img/box9-img-3.0df38d2f.png";